export default "__VITE_ASSET__DQ5GMR30__"